import dayjs from "dayjs";

import type { RepeatType } from "@/types/batchReservation";

/** 06:00 ~ 23:00, 30분 간격 */
export const TIME_OPTIONS = Array.from({ length: 35 }, (_, i) => {
  const hour = 6 + Math.floor(i / 2);
  const minute = (i % 2) * 30;

  return `${String(hour).padStart(2, "0")}${String(minute).padStart(2, "0")}00`;
});

/** "090000" -> "09:00" */
export const formatTime = (t: string) =>
  t ? `${t.slice(0, 2)}:${t.slice(2, 4)}` : "";

export const inputCls =
  "rounded-lg border border-gray-200 px-3 py-2 text-small w-full outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary transition-all";

export interface FormState {
  bldCd: string;
  plcCd: string;
  startDate: string;
  endDate: string;
  repeatType: RepeatType;
  repeatDays: string[];
  monthlyDays: string;
  startTime: string;
  endTime: string;
  purpose: string;
}

export const initialForm: FormState = {
  bldCd: "PTK_PTK",
  plcCd: "",
  startDate: dayjs().format("YYYY-MM-DD"),
  endDate: dayjs().add(1, "month").format("YYYY-MM-DD"),
  repeatType: "weekly",
  repeatDays: [],
  monthlyDays: "",
  startTime: "090000",
  endTime: "100000",
  purpose: "",
};

export const BUILDINGS = [
  { code: "PTK_PTK", label: "본관" },
  { code: "PTK_PMC", label: "선교관" },
];
